import { render, staticRenderFns } from "./SettingAddTab.vue?vue&type=template&id=434dd676&"
import script from "./SettingAddTab.vue?vue&type=script&lang=js&"
export * from "./SettingAddTab.vue?vue&type=script&lang=js&"
import style0 from "./SettingAddTab.vue?vue&type=style&index=0&id=434dd676&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports